import { PropsWithChildren } from 'react';

type ConditionProps = {
  condition: boolean;
  fallback: React.ReactNode;
};
/**
 * 특정 조건(`condition`)에 따라 `children` 또는 `fallback`을 렌더링하는 컴포넌트.
 *
 * @param {boolean} condition - 렌더링할 조건 (`true`이면 `children`, `false`이면 `fallback`)
 * @param {React.ReactNode} fallback - 조건이 `false`일 때 보여줄 대체 UI
 * @param {React.ReactNode} children - 조건이 `true`일 때 보여줄 요소 (기본 컨텐츠)
 * @returns {JSX.Element} 조건에 따라 `children` 또는 `fallback`을 포함하는 `<div>`
 *
 * @example
 * ```tsx
 * <Condition condition={isLoggedIn} fallback={<p>로그인이 필요합니다.</p>}>
 *   <p>환영합니다, 사용자님!</p>
 * </Condition>
 * ```
 */
function Condition({ condition, fallback, children }: PropsWithChildren<ConditionProps>) {
  return <div>{condition ? children : fallback}</div>;
}

export default Condition;
